import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products/agentic-vault")({
  loader: async () => {
    throw redirect({ to: "/products/$slug", params: { slug: "vault" } });
  },
});
